<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="MenuIcon"
          icon-right
          statistic="Cadastros Gerais"
          statisticTitle=""
          :color="color"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <router-link to="/marcas">
          <statistics-card-line
            hideChart
            icon="TruckIcon"
            statistic="Marcas"
            statisticTitle=""
            color="success"
            type="area"
          ></statistics-card-line>
        </router-link>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
       
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="ListIcon"
          icon-right
          statistic="Administração de Sistema"
          statisticTitle=""
          :color="color"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
       
      </div>
      <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
       
      </div>
      <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
       
      </div>
      <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
        
      </div>
    </div>
  </div>
</template>


<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
export default {
  components: { StatisticsCardLine },
  data() {
    return {
      backgroundLoading: "primary",
      colorLoading: "#fff",
      file: "",
      fileName: "",
    };
  },
  computed: {},
  methods: {},
  created() {},
};
</script>
 
<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>